import { Injectable, inject } from '@angular/core';
import { formatNumber } from '@angular/common';
import { Month } from '../model/grid-calendar';
import { HisUiService } from '../../core/service/base/his-ui.service';

@Injectable( {
    providedIn: 'root'
} )
export class GridCalendarUtils {
    private readonly hisUiService = inject(HisUiService);


    public createMonthByString( monthYear: string ): Month | null {
        if ( !monthYear || monthYear.length !== 6 ) {
            return null;
        }

        const year = Number( monthYear.substring( 0, 4 ) );
        const month = Number( monthYear.substring( 4 ) );
        return new Month( [], month, year, '' );
    }

    public createMonthByDate( date: Date ): Month {
        return new Month( [], date.getMonth() + 1, date.getFullYear(), '' );
    }

    public getCurrentMonth(): Month {
        const today = new Date();
        return this.createMonthByDate( today );
    }

    public getDatesBetween( from: Date, to: Date ): Date[] {
        const dates: Date[] = [];
        let date: Date = from;

        while ( date <= to ) {
            dates.push( date );
            date = new Date( date );
            date.setDate( date.getDate() + 1 );
        }

        return dates;
    }

    /**
     * Liefert den Monat im Format yyyyMM
     */
    public getAsString( month: Month ): string {
        return String( month.year ) + formatNumber( month.monthId, 'de-DE', '2.0' );
    }

    public incrementMonth( month: Month ): Month {
        return this.calcMonth( month, true );
    }

    public decrementMonth( month: Month ): Month {
        return this.calcMonth( month, false );
    }

    private getDate( month: Month ): Date {
        return new Date( month.year, month.monthId - 1 );
    }

    private calcMonth( month: Month, increment: boolean ): Month {
        const date = this.getDate( month );
        if ( increment ) {
            date.setMonth( date.getMonth() + 1 );
        } else {
            date.setMonth( date.getMonth() - 1 );
        }

        return new Month( month.days, date.getMonth() + 1, date.getFullYear(), month.monthOfYear );
    }

    /**
     * Wenn @param input ein I18n-Schlüssel ist, dann wird er übersetzt. 
     * Ist es einfacher Text, so wird dieser zurückgegeben
     */
    public getText( input: string ): string {
        // Leerstring bei falsy values 
        if ( !input ) {
            return '';
        }
        let translation = this.hisUiService.translate( input );
        if ( translation.startsWith( '???' ) && translation.endsWith( '???' ) ) {
            return input;
        }
        return translation;
    }
}
